import React from "react";
import { useResume } from "../../data/dataCtx";

export const  Footer = ()=>   {
    const resume = useResume();
    return (
      <footer class="bg-white py-4 mt-auto">
          <div class="container px-5">
              <div class="row align-items-center justify-content-center flex-column flex-sm-row">
                  <div class="col-auto"><div class="small m-0">Copyright &copy; {resume.main?.name}  2024</div></div>
              </div>
          </div>
      </footer>
    );
  }


